export default (rawText: string, formatted: string, groupSeparator: string): number =>
    formatted.split(groupSeparator).length - rawText.trim().split(groupSeparator).length;
